import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table", "link"]

  toggleRows() {
    var rows = $(this.tableTarget).find(".hidden-results")
    var link = $(this.linkTarget)

    if (rows.hasClass("hidden")) {
      rows.removeClass("d-none")
      link.text("Show less")
    } else {
      rows.addClass("d-none")
      link.text("Show more")
    }
  }
}
